import Client from "fhir-kit-client";
import i18n from "i18next";
import { FunctionComponent, useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import VulcanPage from "../../components/VulcanPage/VulcanPage";
import InformationSystemMap from "../../components/InformationSystemMap/InformationSystemMap";
import DeviceService from "../../services/fhir/DeviceService";
import InformationSystemMappingService from "../../services/software/InformationSystemMappingService";
import { InformationSystemMap as InformationSystemMapModel, InformationSystemNode } from "../../services/software/InformationSystemMapping.types";
import "./SoftwareMapping.css";

const emptyMap: InformationSystemMapModel = {
    nodes: [],
    links: [],
};

const SoftwareMapping: FunctionComponent = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>();
    const [softwareMap, setSoftwareMap] = useState<InformationSystemMapModel>(emptyMap);

    const navigate = useNavigate();

    const fhirClient = useMemo(() => new Client({
        baseUrl: process.env.REACT_APP_FHIR_URL ?? "fhir",
    }), []);

    const informationSystemMappingService = useMemo(() => new InformationSystemMappingService(
        new DeviceService(fhirClient)
    ), [fhirClient]);

    const loadSoftwareMap = useCallback(async () => {
        setLoading(true);
        setError(undefined);

        try {
            setSoftwareMap(await informationSystemMappingService.getSoftwareMap());
        } catch (error) {
            console.log(error);
            setError(i18n.t("softwareMapping.error"));
        } finally {
            setLoading(false);
        }
    }, [informationSystemMappingService]);

    const onNodeClick = useCallback((node: InformationSystemNode) => {
        navigate(`/SoftwareViewer/${node.id}`);
    }, [navigate]);

    useEffect(() => {
        loadSoftwareMap();
    }, [loadSoftwareMap]);

    return (
        <VulcanPage titleKey="title.softwaremapping" loading={loading} needsLogin={true}>
            <InformationSystemMap
                map={softwareMap}
                loading={loading}
                error={error}
                onNodeClick={onNodeClick}
            />
        </VulcanPage>
    );
};

export default SoftwareMapping;
